export { default } from "./QRScannerController";
export { default as i18n } from "./i18n";

import { ProviedProps } from "./QRScannerController";
export type QRScanner = ProviedProps;
